import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { AdminNav } from '@bw/alloy-react';

import './Navigation.scss';
import composeURL from 'utils/composeURL';

/** Basic navigation component that shows links in the nav bar. */
const Navigation: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();

  if (authState?.isAuthenticated || oktaAuth?.isLoginRedirect()) {
    return null;
  }

  return (
    <AdminNav
      data-bw="admin-nav"
      title="Bandwidth"
      items={[
        {
          'data-bw': 'login',
          label: 'Log in',
          to: composeURL('/login'),
        },
        {
          'data-bw': 'subItem1',
          label: 'Privacy Notice',
          to: 'https://bandwidth.com/privacy',
        },
        {
          'data-bw': 'subItem4',
          label: 'Service Status',
          to: 'https://status.bandwidth.com/',
        },
      ]}
      id="top-nav"
    />
  );
};

export default Navigation;
